
import React from 'react'

// eslint-disable-next-line react/prop-types
const TableSVG = ({className, style}) => (

  <svg className={className} style={style} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M11.4783 0H0.521742C0.234 0 0 0.234 0 0.521742V11.4783C0 11.766 0.234 12 0.521484 12H11.4783C11.766 12 12 11.766 12 11.4783V0.521742C12 0.234 11.766 0 11.4783 0ZM4.17391 8.34783V5.73914H7.82609V8.34783H4.17391ZM7.82609 11.4783V8.86957H4.17391V11.4783H7.82609ZM7.82609 2.60869V5.21738H4.17391V2.60869H7.82609ZM11.4783 5.21738V2.60869H8.34783V5.21738H11.4783ZM3.65217 5.2174H0.521742V2.60869H3.65217V5.2174ZM3.65217 5.73914H0.521742V8.34783H3.65217V5.73914ZM8.34783 5.73914H11.4783V8.34783H8.34783V5.73914ZM11.4783 2.08697V0.521742H0.521742V2.08697H11.4783ZM0.521742 8.86957H3.65217V11.4783H0.521742V8.86957ZM8.34783 8.86957V11.4783H11.4783V8.86957H8.34783Z" fill="#41A017"/>
</svg>




  )

  export default TableSVG
